module.exports = __webpack_public_path__ + "img/goodreads.77be57c4.png";